// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"68ab1fec","93":"17616431","180":"409c287d","186":"6b01c157","422":"84a482cc","453":"cb92b0c6","460":"094bf591","497":"247970ab","533":"a4094ff0","812":"647a6242"}[chunkId] + ".chunk.js";
};